import { createFileRoute } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { PageHead, Panel } from "@/project/components/dashboard-shell";
import { causes, institutions, formatINR, progressPct } from "@/project/data/sample";

export const Route = createFileRoute("/institution/causes")({ component: InstCauses });

function InstCauses() {
  const inst = institutions[0];
  const myCauses = causes.filter((c) => c.institutionId === inst.id);
  return (
    <>
      <PageHead title="Causes" subtitle="Create and manage your donation campaigns." action={
        <button className="inline-flex items-center gap-2 rounded-full bg-[var(--maroon)] px-4 py-2 text-sm font-semibold text-[var(--cream)]"><Plus className="h-4 w-4" />New cause</button>
      } />
      <Panel title="Your causes">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px] text-sm">
            <thead className="text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <tr className="text-left"><th className="py-2.5">Cause</th><th>Required</th><th>Raised</th><th>%</th><th>Status</th></tr>
            </thead>
            <tbody className="divide-y divide-border">
              {myCauses.map((c) => (
                <tr key={c.id} className="hover:bg-muted/30">
                  <td className="py-3 font-medium text-foreground">{c.title}</td>
                  <td className="text-muted-foreground">{formatINR(c.required)}</td>
                  <td className="text-[var(--maroon)] font-extrabold">{formatINR(c.raised)}</td>
                  <td className="font-semibold text-foreground/80">{progressPct(c)}%</td>
                  <td>
                    <span className="inline-flex items-center rounded-full bg-amber-50 px-2.5 py-0.5 text-[11px] font-semibold text-amber-700 border border-amber-200 uppercase">
                      {c.urgency}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </>
  );
}